import React from 'react';
import moment from 'moment';
import { orderBy } from 'lodash-es';
import {
  Heading3,
  Heading4,
} from '@docon/docon-ui-library';
import { getTimeFromMinutes } from 'utils';

function Timings({
  title = 'Today',
  day = moment().day(),
  shifts = [],
}: any) {

  const orderedShifts = orderBy(shifts, ['startTime'], ['asc']);

  function renderContent() {
    let hasAvailableShift = false;

    const node = orderedShifts.map((shift: any) => {
      const startDate = moment(shift.validFrom, 'YYYY-MM-DD HH:mm:ss ZZ');
      const endDate = moment(shift.validTill, 'YYYY-MM-DD HH:mm:ss ZZ');

      if (!(
        shift.days.includes(day === 0 ? 7 : day) &&
        shift.status !== 'deleted' &&
        moment().isBetween(startDate, endDate)
      )) return null;

      hasAvailableShift = true;
      let suffix = '';
      if (shift.shiftTypes.length === 1) {
        if (shift.shiftTypes[0] === 'walkin') {
          suffix = 'Walk-In';
        } else suffix = shift.shiftTypes[0];
      }

      return (
        <Heading4
          key={shift.shiftID}
          title={`${getTimeFromMinutes(shift.startTime)} - ${getTimeFromMinutes(shift.endTime)} ${suffix ? `(${suffix})` : ''}`}
        />
      );
    });

    if (hasAvailableShift) return node;
    return <Heading4 title={'Closed'} />;
  }

  return (
    <>
      <Heading3 fontWeight={600} title={title} />

      {renderContent()}
    </>
  );
}

export default Timings;